import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Viewer-role guard: surface a friendly toast when the read-only middleware
// blocks a write attempt. Rejects the promise so the caller's catch still runs.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 403) {
      const detail = err.response.data?.detail;
      if (typeof detail === "string" && detail.includes("צפייה בלבד")) {
        toast.error(detail);
      }
    }
    return Promise.reject(err);
  }
);

export default api;
